module.exports = __webpack_public_path__ + "static/media/ir.5a82082f.svg";